import {AuthActions, AuthActionType} from './auth.types';
import {AuthState, Session} from "../../util/interfaces";


const initialSession: Session = {
  csrfToken: '',
  isAuthenticated: false,
  captchaKey: '',
  accessTypes: [],
  poyntSignupUrl: ''
}

const initialState: AuthState = {
  captchaKey: '',
  noCaptchaKey: '',
  captchaDisabled: true,
  session: initialSession,
  signupStatus: null,
  signupErrorMessage: null,
  loginErrorMessage: null,
  verify2faError: false,
  resetPasswordErrorMessage: null,
  errorId: 0,
  recaptchaComplete: false,
  resetKey: null,
  resetPasswordStatus: null,
  verifyingEmail: false,
  verifying2FA: false,
  allowToken: null,
  rejectToken: null
}

export const authReducer = (state: AuthState = initialState, action: AuthActionType): AuthState => {
  switch(action.type){
    case AuthActions.SUCCESS_GET_SESSION: {
      return {...state, session: {...state.session, ...action.payload}, noCaptchaKey: action.payload.noCaptchaKey, captchaKey: action.payload.captchaKey, captchaDisabled: action.payload.captchaDisabled}
    }
    case AuthActions.SUCCESS_LOGOUT: {
      return {...initialState}
    }
    case AuthActions.SUCCESS_SIGNUP: {
      return {...state, signupStatus: 'success'}
    }
    case AuthActions.FAILED_LOGIN: {
      return {...state, loginErrorMessage: action.payload, errorId: state.errorId + 1}
    }
    case AuthActions.FAILED_SIGNUP: {
      return {...state, signupErrorMessage: action.payload, errorId: state.errorId + 1}
    }
    case AuthActions.SUCCESS_RECAPTCHA: {
      return {...state, recaptchaComplete: true}
    }
    case AuthActions.FAILED_VERIFY_2FA: {
      return {...state, verify2faError: true, errorId: state.errorId + 1}
    }
    case AuthActions.SET_RESET_KEY: {
      return {...state, resetKey: action.payload}
    }
    case AuthActions.SUCCESS_FORGOT_PASSWORD: {
      return {...state, resetPasswordStatus: 'initiated'}
    }
    case AuthActions.SUCCESS_RESET_PASSWORD: {
      return {...state, resetPasswordStatus: 'complete'}
    }
    case AuthActions.SUCCESS_DISABLE_RESET_PASSWORD: {
      return {...state, resetPasswordStatus: 'disabled'}
    }
    case AuthActions.FAILED_FORGOT_PASSWORD: {
      return {...state, resetPasswordStatus: 'error', resetPasswordErrorMessage: action.payload}
    }
    case AuthActions.FAILED_RESET_PASSWORD: {
      return {...state, resetPasswordStatus: 'error', resetPasswordErrorMessage: action.payload}
    }
    case AuthActions.FAILED_DISABLE_RESET_PASSWORD: {
      return {...state, resetPasswordStatus: 'error', resetPasswordErrorMessage: action.payload}
    }
    case AuthActions.CLEAR_RESET_PASSWORD_STATUS: {
      return {...state, resetPasswordStatus: null}
    }
    case AuthActions.SET_VERIFYING_EMAIL: {
      return {...state, verifyingEmail: action.payload}
    }
    case AuthActions.SET_VERIFYING_2FA: {
      return {...state, verifying2FA: action.payload}
    }
    case AuthActions.CLEAR_ERROR: {
      if(action.payload === state.errorId || action.payload === 0) {
        return {
          ...state,
          signupErrorMessage: null,
          loginErrorMessage: null,
          verify2faError: false,
          resetPasswordErrorMessage: null,
        }
      } else {
        return {...state};
      }
    }
    case AuthActions.SET_ALLOW_TOKEN: {
      return {...state, allowToken: action.payload, rejectToken: null}
    }
    case AuthActions.SET_REJECT_TOKEN: {
      return {...state, rejectToken: action.payload, allowToken: null}
    }
    default:
      return state
  }
}

